import { string, object, z, number } from 'zod'
import { toTypedSchema } from '@vee-validate/zod'
export const emailSchema = string().nonempty('Email is required').email('Must be a valid email')

export const passwordSchema = string()
  .nonempty('Password is required')
  .min(8, 'Password must be at least 8 characters')
export const confirmPasswordSchema = string()
  .nonempty('New Password is required')
  .min(8, 'New Password must be at least 8 characters')

export const loginSchema = toTypedSchema(
  object({
    email: emailSchema,
    password: passwordSchema,
  }),
)
export const bankAccountSchema = toTypedSchema(
  object({
    account_number: string()
      .nonempty('Account number is required')
      .min(10, 'Account number is wrong'),
    bank_code: string().nonempty('Bank is required'),
  }),
)

const phoneSchema = string()
  .nonempty('Phone number is required')
  .regex(
    /^\+?234[789]\d{9}$|^0[789]\d{9}$/,
    'Invalid phone number'
  )

export const orderSchema = toTypedSchema(
  object({
    delivery_address: string().nonempty('Delivery Address is required'),
    phone: phoneSchema,
    // notes: string().nullable(),
    // items: z.array(z.object({
    //   id: z.number(),
    //   name: z.string(),
    //   price: z.number(),
    //   quantity: z.number()
    // }))
  }),
)
export const resetPasswordSchema = toTypedSchema(
  object({
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: confirmPasswordSchema,
  }).refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords should match',
    path: ['confirmPassword'],
  }),
)
export const addMemberSchema = toTypedSchema(
  object({
    email: emailSchema,
  }),
)

export const redirectUrlSchema = z
  .string()
  .regex(/^(https?:\/\/|\/)[^\s]*$/, "Invalid URL: Must start with 'http://', 'https://', or '/'")

export const integrationSchema = toTypedSchema(
  object({
    apiKey: string().nonempty('Api Key is required'),
    apiSecret: string().nonempty('Api Secret is required'),
  }),
)

export const feedbackSchema = toTypedSchema(
  object({
    name: string().nonempty('Name is required'),
    email: emailSchema,
    message: string().nonempty('Message is required'),
  }),
)

export const profileSchema = toTypedSchema(
  object({
    name: string().nonempty('Name is required'),
    email: emailSchema,
    photo: z.any().optional(),
  }),
)

export const productSchema = toTypedSchema(
  object({
    name: string()
      .nonempty('Product name is required')
      .max(255, 'Product name must be less than 255 characters'),
    description: string().optional(),
    price: string()
      .nonempty('Price is required')
      .refine((val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0, {
        message: 'Price must be a positive number',
      }),
    stock: string().nullable().optional(),
    // stock: string()
    //   .nonempty('Stock quantity is required')
    //   .refine((val) => !isNaN(parseInt(val)) && parseInt(val) >= 0, {
    //     message: 'Stock must be a non-negative number'
    //   }),
    category_id: number().nullable().optional(),
    sub_category_id: number().nullable().optional(),
    is_available: z.boolean().default(true),
  }),
)

export const businessSchema = toTypedSchema(
  object({
    name: string()
      .nonempty('Business name is required')
      .max(255, 'Business name must be less than 255 characters'),
    description: string().nonempty('Description is required'),
    address: string().nonempty('Address is required'),
    phone: phoneSchema,
    logo: string().optional(),
    packs: number().optional().nullable(),
    is_active: z.boolean().default(true),
  }),
)

export const updatePasswordSchema = toTypedSchema(
  object({
    current_password: string().nonempty('Current password is required'),
    password: string()
      .nonempty('New password is required')
      .min(8, 'Password must be at least 8 characters'),
    // .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    // .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    // .regex(/[0-9]/, 'Password must contain at least one number'),
    password_confirmation: string().nonempty('Password confirmation is required'),
  }).refine((data) => data.password === data.password_confirmation, {
    message: 'Passwords should match',
    path: ['password_confirmation'],
  }),
)

export const forgotPasswordSchema = toTypedSchema(
  object({
    email: emailSchema,
  }),
)

export const registerSchema = toTypedSchema(
  object({
    name: string().nonempty('Name is required'),
    email: emailSchema,
    phone: phoneSchema,
    address: string().nonempty('Address is required'),

    password: passwordSchema,
    confirmPassword: confirmPasswordSchema,
    // role: string().nonempty('Role is required'),
    business_category: string().optional(),
    other_category: string().optional(),
    terms: z.boolean().refine((val) => val === true, {
      message: 'You must agree to the terms and conditions',
    }),
  }).refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords should match',
    path: ['confirmPassword'],
  }),
)
